import { RefObject, useLayoutEffect, useState } from 'react';

/**
 * Находит внутри отрендеренного контента статьи контейнер с id, оставленный
 * useContentDealsBannerNew на месте маркера `data-name="deal-experiment-banner"`,
 * чтобы смонтировать в него DealsBanner через портал.
 */
export const useFindDealsBannerMountNode = (
  contentRef: RefObject<HTMLElement | null>,
  enabled: boolean,
  containerId: string | null,
  content: string,
): HTMLElement | null => {
  const [mountNode, setMountNode] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    if (!enabled || !containerId || !contentRef.current) {
      setMountNode(null);

      return;
    }

    setMountNode(contentRef.current.querySelector<HTMLElement>(`#${containerId}`));
  }, [content, contentRef, containerId, enabled]);

  return mountNode;
};
